export default {
  fontFamily: ["Lato", "Helvetica", "Arial", "sans-serif"].join(","),
  h1: {
    fontWeight: "bold",
    color: "#283040",
    fontSize: "1.875rem",
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: "bold",
    color: "#283040",
    fontSize: 29,
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: "bold",
    color: "#283040",
    fontSize: 24,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: "bold",
    color: "#283040",
    fontSize: "100%",
    lineHeight: 1.875,
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: "bold",
    fontSize: "100%",
    lineHeight: 0.875,
    color: "#283040",
    letterSpacing: "-0.05px",
  },
  h6: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#283040",
    letterSpacing: "-0.05px",
  },
  overline: {
    fontWeight: "bold",
    color: "#283040",
  },
};
